module.exports = __webpack_public_path__ + "static/img/6.0339f84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/6.png
// module id = uOUA
// module chunks = 0